import { useParams } from "react-router";
import { trpc } from "../../utils/trpc";

export default function AuthFooter() {
	const utils = trpc.useContext();

	const { server_id } = useParams<{ server_id: string }>();

	const getSyncsOrAuthURLQuery = trpc.gcal.getSyncsOrAuthURL.useQuery({
		guild_id: server_id,
	});

	const gcalRemoveAuthMutation = trpc.gcal.removeAuth.useMutation({
		onSuccess: () => {
			utils.gcal.getSyncsOrAuthURL.invalidate();
		},
	});

	return (
		<div className="flex flex-col gap-2 mt-auto has-text-right">
			<div>
				<span className="grey-text">
					Connected Google Calendar account:{" "}
				</span>
				<span className="whitespace-nowrap">
					<span className=" grey-text has-text-weight-bold">
						{getSyncsOrAuthURLQuery.data.email}
					</span>{" "}
					(
					<a
						className="secondary-link"
						onClick={() => {
							gcalRemoveAuthMutation.mutate();
						}}
					>
						disconnect
					</a>
					)
				</span>
			</div>
		</div>
	);
}
